import _ from 'underscore'
import apiAdminLib from '../../lib/apiAdminLib'
import * as types from '../mutation-types'

const state = {
  auth: {},
  user: {}
}

const getters = {
  auth: state => state.auth,
  user: state => state.user,
  userIsAdmin (state) {
    if (_.isEmpty(state.user)) {
      return false
    }

    if (!('roles' in state.user)) {
      return false
    }
    return _.find(state.user.roles, (item) => {
      return item.name === apiAdminLib.ROLE_ADMIN
    }) !== undefined
  }
}

const actions = {
  getUser ({ commit }) {
    if (!('userId' in state.auth)) {
      console.log('userProfile store - no logged in user')
      return
    }
    apiAdminLib.fetchUser(state.auth.userId)
    .then((user) => {
      commit(types.USER_PROFILE_SET, user)
    })
  }
}

const mutations = {
  [types.USER_PROFILE_LOGIN] (state, auth) {
    state.auth = auth
  },

  [types.USER_PROFILE_SET] (state, user) {
    state.user = user
  },

  [types.USER_PROFILE_LOGOUT] (state) {
    state.user = {}
    state.auth = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userProfile.js